export default "__VITE_ASSET__IyET_Aza__"